import Navbar from '../component/Navbar';
import Footer from '../component/Footer';
import EventsHero from '../component/EventsHero';
import PastEvents from '../component/PastEvents';

export default function OurEvents() {
  return (
    <div>
      <Navbar />
      <EventsHero />
      <PastEvents />
      <Footer />
    </div>
  );
}
